export enum ReservationChannel {
  BIRDNEST = 'birdnest',
  AIRBNB = 'airbnb',
  BOOKING = 'booking',
  EXPEDIA = 'expedia',
  VRBO = 'vrbo',
  CALL_CENTER = 'CallCenter',
  WHATSAPP = 'WhatsApp',
  FACEBOOK = 'Facebook',
  INSTAGRAM = 'Instagram',
  REFERRAL = 'Referral',
  TMC = 'TMC',
  CORPORATE_ACCOUNTS = 'CorporateAccounts',
  BROKER = 'Broker',
  ACQUISITION_TEAM = 'AcquisitionTeam',
  BLUE_KEYS = 'BlueKeys',
  AHMED_ALI = 'AhmedAli'
}
